export const lafiaUser_profile_img_path = (state) => {
  const profileImage = state.lafia_user.profile_image
  const snsProfileImage = state.lafia_user.sns_profile_image

  // 우선순위: 사용자가 설정한 이미지 > SNS 프로필 이미지 > default.png
  // 1. 사용자가 직접 설정한 이미지가 있는 경우 (default.png가 아닌 경우)
  if (profileImage && profileImage !== "default.png") {
    return profileImage.includes("/") ? profileImage : "/upload/user/profile_image/" + profileImage
  }
  // 2. SNS 프로필 이미지가 있는 경우
  if (snsProfileImage) {
    return snsProfileImage
  }
  // 3. 기본 이미지
  return "/upload/user/profile_image/lafia-profile-cameo-v1.png"
}

export const isKRW = (state) => state.lang === "ko"

// ==================== JWT 인증 Getters ====================

// 사용자 로그인 상태 확인 (lafia_user 기반)
export const isAuthenticated = (state) => state.lafia_user.is_logined

export const accessToken = (state) => state.accessToken

export const userType = (state) => state.lafia_user.userType || "user"

export const isAdmin = (state) => (state.lafia_user.userType || "user") === "admin"

export const isStaff = (state) => (state.lafia_user.userType || "user") === "staff"

// 사용자 프로필 이미지 경로 (lafia_user 기반)
export const jwtUserProfileImagePath = (state) => {
  const profileImage = state.lafia_user.profile_image
  const snsProfileImage = state.lafia_user.sns_profile_image

  // 우선순위: 사용자가 설정한 이미지 > SNS 프로필 이미지 > default.png
  // 1. 사용자가 직접 설정한 이미지가 있는 경우 (default.png가 아닌 경우)
  if (profileImage && profileImage !== "default.png") {
    return profileImage.includes("/") ? profileImage : "/upload/user/profile_image/" + profileImage
  }
  // 2. SNS 프로필 이미지가 있는 경우
  if (snsProfileImage) {
    return snsProfileImage
  }
  // 3. 기본 이미지
  return "/upload/user/profile_image/lafia-profile-cameo-v1.png"
}

// 사용자 이름 (없으면 userId 반환)
export const jwtUserDisplayName = (state) => {
  return state.lafia_user.name || state.lafia_user.user_id || ""
}
